import React, { useState } from 'react';
import clsx from 'clsx';
import PhoneInput from 'react-phone-input-2';

import {
  InputBase,
  makeStyles,
  TextField,
  Typography,
  FormControlLabel,
  // Grid,
  Checkbox,
  Button,
} from '@material-ui/core';

import Style from './Style';
import Buttons from '../Buttons';
import { validateEmail } from '../../../Utils/helper';
import CustomerPopup from '../../../EstimatorComp/AddEditCustomerPopup';

const useStyles = makeStyles(() => Style());

export default function CustomerFields({ setToggle }) {
  const classes = useStyles();

  const [customer, setCustomer] = useState({});
  const [errors, setErrors] = useState();
  const [openCustomerPopup, setOpenCustomerPopup] = useState(false);

  const handleChangeFields = (e) => {
    const { name, value } = e.target;
    setCustomer({ ...customer, [name]: value });

    if (name === 'name' || name === 'phone' || name === 'email') {
      setErrors({
        ...errors,
        [name]: false,
      });
    }
  };

  // handle validations
  const checkValidation = () => {
    const errorObj = {};

    let isValid = true;

    const { name, phone, email } = customer;

    if (!name?.trim()) {
      errorObj.name = true;
      isValid = false;
    }
    if (!phone || phone?.length < 11) {
      errorObj.phone = true;
      isValid = false;
    }
    if (email && !validateEmail(email)) {
      errorObj.email = true;
      isValid = false;
    }

    setErrors({
      ...errors,
      ...errorObj,
    });

    return isValid;
  };

  const customerDetails = () => {
    if (checkValidation()) {
      return customer;
    }
  };
  const {
    name = '',
    email = '',
    phone = '',
    address = '',
    company = '',
    referalSource = '',
    notes = '',
    usDotNumber = null,
    pstNumber = null,
    excludeEmail,
    excludeSms,
    isTaxExempt,
  } = customer;

  const handleAdditionalInfoSave = (additionalInfo) => {
    setCustomer({
      ...customer,
      ...additionalInfo,
    });
  };

  return (
    <div className={classes.custom_customer__main}>
      <Typography className={classes.heading}>Add Customer</Typography>
      <div className={clsx(classes.fields__main, 'w-100')}>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography
              className={clsx(classes.label, errors?.name && classes.is__error)}
            >
              Customer Name*
            </Typography>{' '}
            <TextField
              type='text'
              name='name'
              placeholder='Enter Customer Name*'
              error={errors?.name || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              onChange={handleChangeFields}
              className={clsx(
                classes.data__field,
                errors?.name && classes.is__error__border,
              )}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography
              className={clsx(
                classes.label,
                errors?.email && classes.is__error,
              )}
            >
              Customer Email
            </Typography>{' '}
            <TextField
              type='text'
              name='email'
              placeholder='Enter Customer Email'
              value={email}
              onChange={handleChangeFields}
              error={errors?.email || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.email && classes.is__error__border,
              )}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography
              className={clsx(
                classes.label,
                errors?.phone && classes.is__error,
              )}
            >
              Phone Number*
            </Typography>{' '}
            <div className={classes.phone__field}>
              <PhoneInput
                country='us'
                placeholder='Phone Number'
                name='phone'
                InputProps={{ disableUnderline: true }}
                value={phone}
                error={errors?.phone}
                containerClass={clsx(
                  errors?.phone && classes.is__error__underline,
                )}
                onChange={(value, country, e, formattedValue) => {
                  handleChangeFields({
                    target: {
                      name: 'phone',
                      value: formattedValue,
                    },
                  });
                }}
              />
            </div>
          </div>{' '}
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Address</Typography>
            <TextField
              type='text'
              name='address'
              placeholder='Enter Address'
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={classes.data__field}
              value={address || ''}
              onChange={handleChangeFields}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Company</Typography>
            <TextField
              type='text'
              name='company'
              placeholder='Enter Company'
              value={company}
              onChange={handleChangeFields}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={classes.data__field}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Referral Source</Typography>
            <TextField
              type='text'
              name='referalSource'
              placeholder='Enter Referral Source'
              onChange={handleChangeFields}
              value={referalSource}
              InputProps={{
                disableUnderline: true,
              }}
              className={classes.data__field}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>USDOT Number</Typography>
            <TextField
              type='text'
              name='usDotNumber'
              placeholder='Enter USDOT Number'
              value={usDotNumber}
              onChange={handleChangeFields}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={classes.data__field}
            />
          </div>{' '}
          <div className={classes.flex__field}>
            <Typography className={classes.label}>PST Number</Typography>
            <TextField
              type='text'
              name='pstNumber'
              placeholder='Enter PST Number'
              value={pstNumber}
              onChange={handleChangeFields}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={classes.data__field}
            />
          </div>
        </div>

        <div className={classes.additional__information}>
          <Button
            disableRipple
            href=''
            onClick={() => setOpenCustomerPopup(true)}
          >
            Additional Information
          </Button>
        </div>

        <div className='d-flex space-between'>
          <div
            // className={classes.fledx__field}
            style={{ width: '100%' }}
          >
            <Typography className={classes.label}>Customer Notes</Typography>
            <div
              style={{
                border: '1px solid #AEB6B7',
                borderRadius: '8px',
                padding: '0 1rem',
              }}
            >
              <InputBase
                placeholder='Add a note'
                multiline
                rows={3}
                fullWidth
                id='notes'
                onChange={handleChangeFields}
                name='notes'
                value={notes}
              />
            </div>
          </div>
        </div>
        <div className='d-flex space-between'>
          {/* <FormGroup> */}
          <FormControlLabel
            control={
              <Checkbox
                style={{
                  color: 'var(--color-primary)', // Set the color of the checkbox to purple
                }}
              />
            }
            label={
              <Typography className={classes.label}>
                Please check to exclude this customer from automated Email
                notifications.
              </Typography>
            }
            checked={Boolean(excludeEmail)}
            name='excludeEmail'
            onChange={(e) => {
              handleChangeFields({
                target: {
                  value: e.target.checked,
                  name: 'excludeEmail',
                },
              });
            }}
          />
        </div>
        <div className='d-flex space-between'>
          <FormControlLabel
            checked={Boolean(excludeSms)}
            name='excludeSms'
            onChange={(e) => {
              handleChangeFields({
                target: {
                  value: e.target.checked,
                  name: 'excludeSms',
                },
              });
            }}
            control={
              <Checkbox
                style={{
                  color: 'var(--color-primary)', // Set the color of the checkbox to purple
                }}
              />
            }
            label={
              <Typography
                style={{
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20px',
                  color: '#6D7D8B',
                }}
              >
                Please check to exclude this customer from automated SMS
                notifications.
              </Typography>
            }
          />
          {/* </FormGroup> */}
        </div>
        <div className='d-flex space-between'>
          <FormControlLabel
            checked={Boolean(isTaxExempt)}
            name='isTaxExempt'
            onChange={(e) => {
              handleChangeFields({
                target: {
                  value: e.target.checked,
                  name: 'isTaxExempt',
                },
              });
            }}
            control={
              <Checkbox
                style={{
                  color: 'var(--color-primary)', // Set the color of the checkbox to purple
                }}
              />
            }
            label={
              <Typography
                style={{
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20px',
                  color: '#6D7D8B',
                }}
              >
                Tax Exempt
              </Typography>
            }
          />
          {/* </FormGroup> */}
        </div>
      </div>
      {/* Actions */}
      <Buttons
        onCancel={() => {
          setToggle(false);
        }}
        getCustomerObj={customerDetails}
        disabled={!name || !phone}
      />
      {openCustomerPopup && (
        <CustomerPopup
          openCustomerPopup={openCustomerPopup}
          setOpenCustomerPopup={setOpenCustomerPopup}
          isAdditionalInfo
          customerData={customer}
          handleAdditionalInfoSave={handleAdditionalInfoSave}
        />
      )}
    </div>
  );
}
